export default __webpack_public_path__ + "static/media/lunch1.2910c084.png";